export default __webpack_public_path__ + "static/media/menu_mail.80a59267.svg";